import React from 'react';
import { Table, TableHead, TableRow, TableCell, TableBody, Button, Box } from '@mui/material';
import { COLOR_PRIMARY_2, WATER_MARK_COLOR } from 'src/colors';
import { PRO_CTA, UNLOCK_CTA, EXPERT_CTA, EXPERT_CTA_FOR_TAILOR_REGION } from 'src/const';
import { useSelector } from 'react-redux';
import { User } from 'src/interfaces/iuser';


const CTAButton = ({ handleOnCLick, user, dashboardLayoutView, userTailorMarketAccess }) => {
  const upgradeMessage = () => {
    if (!userTailorMarketAccess && dashboardLayoutView == 'dashboard') {
      return EXPERT_CTA_FOR_TAILOR_REGION;
    } else if (user.subscriptionPlan === 'starter' && dashboardLayoutView == 'dashboard') {
      return PRO_CTA;
    }else if (user.subscriptionPlan === 'starter' && dashboardLayoutView == 'map') {
      return EXPERT_CTA;
    } else if (user.subscriptionPlan == 'pro' && dashboardLayoutView == 'map') {
      return EXPERT_CTA;
    } else {
      return UNLOCK_CTA;
    }
  };

  return (
    <>
      <Box
        sx={{
          position: 'absolute',
          height: '100%',
          background: '#fff0',
          top: 0,
          transform: 'translateX(-4px)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backdropFilter: 'blur(1px)',
        }}
      ></Box>
      <Button
        sx={{
          background: 'transparent',
          marginLeft: '-4px',
          fontSize: '20px',
          fontWeight: 500,
          color: COLOR_PRIMARY_2,
          cursor: 'pointer',
          pointerEvents: 'auto',
          textDecoration: 'underline',
        }}
        onClick={() => handleOnCLick((dashboardLayoutView == 'map' || !userTailorMarketAccess) ? 'expert' : 'pro')}
      >
        {upgradeMessage()}
      </Button>
    </>
  );
};

const BasicTable = ({ header, rows, blurredColumns, onButtonClick, dashboardLayoutView ,userTailorMarketAccess}) => {
  const user: User = useSelector(state => (state as any).dashboard.user);
  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          {header.map((column, index) => (
            <TableCell key={index}>{column}</TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody style={{ position: 'relative' }}>
        {rows.map((row, rowIndex) => (
          <TableRow
            key={rowIndex}
            style={{ backgroundColor: rowIndex % 2 === 0 ? '#f5f5f5' : 'white' }}
          >
            {row.map((cell, cellIndex) => {
              const isRowIncludesCTAButton: boolean =
                rowIndex === Math.floor(rows.length / 2) && blurredColumns.includes(cellIndex);
              return (
                <TableCell
                  key={cellIndex}
                  style={{
                    filter:
                      blurredColumns.includes(cellIndex) && !isRowIncludesCTAButton
                        ? 'blur(4px)'
                        : 'none',
                  }}
                >
                  {isRowIncludesCTAButton ? (
                    <CTAButton
                      handleOnCLick={onButtonClick}
                      user={user}
                      dashboardLayoutView={dashboardLayoutView}
                      userTailorMarketAccess={userTailorMarketAccess}
                    />
                  ) : (
                    <>{cell}</>
                  )}
                </TableCell>
              );
            })}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default BasicTable;
